import React from "react";

export const BannerCheckIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g clipPath="url(#clip0_main_banner_check)">
      <path
        d="M17.6521 1.17094C17.2163 0.782701 16.5448 0.815474 16.15 1.24404L6.36615 11.8574L1.74976 8.13645C1.38834 7.84402 0.857754 7.81124 0.455326 8.08855C-0.0291251 8.42385 -0.144471 9.07931 0.193876 9.55578L4.98969 16.2742C5.12041 16.4557 5.28959 16.6247 5.48952 16.7583C6.38921 17.3658 7.61957 17.1415 8.23731 16.2566L8.31677 16.1431L17.8136 2.53732C18.1109 2.11379 18.0494 1.5264 17.6521 1.17094Z"
        fill="#1E3A6D"
      />
    </g>
    <defs>
      <clipPath id="clip0_main_banner_check">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BannerArrowIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M3.33398 10H16.6673M11.6673 15L16.6673 10L11.6673 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
